// extracted by mini-css-extract-plugin
export default {"main":"login_main__09pDc","logo":"login_logo__l3X-j","title":"login_title__Aa3+q"};